import { TableGridHeader } from './../table-grid/table-grid.model';
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import * as _ from 'lodash';

import {
  ActivatedRoute,
  Router
} from '@angular/router';
import { ApproveWorkflowModel, ManageWorkflowService } from 'src/app/modules/manage-workflows/services/manage-workflow.service';
import { WorkflowTableGridHeader } from 'src/app/shared/components/workflow-table-grid/workflow-table-grid.model';
import {
  CONSUMER_MANAGE_WORKFLOWS_URL,
  IN_REVIEW_URL,
  MANAGE_WORKFLOWS_URL,
  NOTIFICATION_ERROR,
  NOTIFICATION_SUCCESS,
  ORC_MANAGE_WORKFLOWS_URL
} from 'src/app/shared/constants/constant';
import {
  ALLOWED_FORMAT,
  DOCUMENT_FILE_SIZE,
  DUPLICATE_FILE_ERROR,
  ERROR_OCCURED_TRY_AGAIN_LATER,
  FILL_ALL_MANDATORY_FIELDS,
  PRINTER_PROOF_DELETED,
  SOMETHING_WENT_WRONG
} from 'src/app/shared/constants/messages';
import { DataCaptureHeader } from 'src/app/shared/models/dataCapture.model';
import { PrinterProofFileUploadDetails } from 'src/app/shared/models/manageWorkflow.model';
import { NotificationAlert } from 'src/app/shared/models/notificationAlert.model';
import {
  UserDetail,
  UserFileDownload
} from 'src/app/shared/models/userDetail.model';
import {
  base64ToArrayBuffer,
  checkForSameFile,
  convertUTCDateToLocalDateMMDDYYYYHHMMSS,
  saveByteArray
} from 'src/app/shared/utilities/util';
import { TextValidator } from 'src/app/shared/validators/textPatternValidator';
import { CoreService } from './../../../core/services/core.service';
import { CONSENT_TO_PUBLISH, BACK_TO_REPORTING_WORKFLOW, CP_QP_MANAGE_WORKFLOWS_URL, ENDORSER_MANAGE_WORKFLOWS_URL, PRINTER_PROOF_ACTION_URL, CP_QP_ORC_MANAGE_WORKFLOWS_URL } from './../../constants/constant';
import { ToasterNotificationService } from './../toaster-notification/toaster-notification.service';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-printer-proof',
  templateUrl: './printer-proof.component.html',
  styleUrls: ['./printer-proof.component.scss'],
})
export class PrinterProofComponent implements OnInit {
  public showSubmittedPrinterProofPopUp: boolean;
  public printerProofForm: FormGroup;
  public submittedPrinterProofForm = false;
  public printerProofData: PrinterProofFileUploadDetails[] = [];
  public alert: NotificationAlert;
  public consentAlert: NotificationAlert;
  public formFileValue: File;
  public DASHBOARD_URL;
  public selectedDelDocument;
  public showDeletePopup = false;
  public popupMessage: string;
  public loginID: number;
  public header: DataCaptureHeader;
  public workflowID: string;
  public yearCode: string;
  public showUnsavedPopup = false;
  public showLoader = false;
  public PrinterProofHeaders: WorkflowTableGridHeader[];
  public isAdmin = false;
  public isEndorser = false;
  public isCPQP = false;
  public isORC = false;
  public isConsumer = false;
  public commentControl = new FormControl(null, [Validators.required, TextValidator(300)]);
  public acknowledgeCheckbox = new FormControl(null);
  public showRejectedPopup = false;
  public submitCommentForm = false;
  public showApprovedPopup = false;
  showComments: boolean;
  alerts: any = [];
  comments: any = [];
  showCpQPRejectedPopup: boolean;
  submitCpQpCommentForm: boolean;
  showCpQpRejectedPopup: boolean;
  isNonConsentedCP: boolean;
  public isReportingCycleLocked = false;
  showConsentedForms: boolean;
  consentedFormHeader: TableGridHeader[];
  consentedFormsData = [];
  viewConsentForm: boolean;
  selectedConsent: any;
  BACK_TO_REPORTING_WORKFLOW = BACK_TO_REPORTING_WORKFLOW;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private manageWorkflow: ManageWorkflowService,
    private coreService: CoreService,
    private toasterNotificationService: ToasterNotificationService,
    private datePipe: DatePipe,
    private httpClient: HttpClient
  ) {
    this.consentedFormHeader = [
      {
        name: 'Deposit Name',
        key: 'nodeDisplayName',
        sortType: 'string',
        type: 'string',
        width: '150px'
      },
      {
        name: 'CP/QP Name',
        key: 'cpqpName',
        sortType: 'string',
        width: '140px'
      },
      {
        name: 'Consented Date',
        key: 'consentPublishDate',
        sortType: 'date',
        sort: 'desc',
        type: 'date',
        width: '160px'
      },
      { name: '', key: '', type: 'view-consent-btn' },
    ];
  }

  ngOnInit(): void {
    const seperatorURL = `/${PRINTER_PROOF_ACTION_URL}`;
    this.DASHBOARD_URL = this.router.url.substr(1, this.router.url.indexOf(seperatorURL)).slice(0, -1);
    if (this.router.url.indexOf(ENDORSER_MANAGE_WORKFLOWS_URL) > -1) {
      this.isEndorser = true;
    } else if (this.router.url.indexOf(CP_QP_MANAGE_WORKFLOWS_URL) > -1) {
      this.isCPQP = true;
    } else if (this.router.url.indexOf(CP_QP_ORC_MANAGE_WORKFLOWS_URL) > -1) {
      if (this.router.url.indexOf(IN_REVIEW_URL) > -1) {
        this.isORC = true;
      } else {
        this.isCPQP = true;
      }
    } else if (this.router.url.indexOf(ORC_MANAGE_WORKFLOWS_URL) > -1) {
      this.isORC = true;
    } else if (this.router.url.indexOf(CONSUMER_MANAGE_WORKFLOWS_URL) > -1) {
      this.isConsumer = true;
    } else if (this.router.url.indexOf(MANAGE_WORKFLOWS_URL) > -1) {
      this.isAdmin = true;
    }
    // this.PrinterProofHeaders = this.getPrinterProofHeaders();
    this.isReportingCycleLocked = sessionStorage.getItem('isCurrentReportingCycleYearLock') === '1';
    if (this.route && this.route.params) {
      this.route.params.subscribe((params) => {
        if (params.workflowID && params.yearCode) {
          this.showLoader = true;
          this.yearCode = params.yearCode;
          this.workflowID = params.workflowID;
          let tabStatus = 1;
          if (this.isEndorser || this.isORC) {
            tabStatus = 2;
          }
          // this.manageWorkflow
          //   .getWorkflowDetails(this.workflowID, tabStatus)
          //   .subscribe((response) => {
          //   });
          this.getPrinterProofData(this.workflowID, this.yearCode);
        }
      });
    }
  }

  getAllComments(printerProofCommentsList): any {
    let comments = [];
    for (const comment of printerProofCommentsList) {
      if (comment.endorserComment) {
        comments = comments.concat(JSON.parse(comment.endorserComment));
      }

      if (comment.cpqpComment) {
        comments = comments.concat(JSON.parse(comment.cpqpComment));
      }
    }
    comments.sort((a, b) => {
      let item1;
      let item2;
      item1 = a.updatedDate ? new Date(a.updatedDate).getTime() : '';
      item2 = b.updatedDate ? new Date(b.updatedDate).getTime() : '';
      if (item1 > item2) {
        return -1;
      } else if (item1 < item2) {
        return 1;
      }
      return 0;
    });
    return comments;
  }

  getAllAlerts(printerProofUserList): NotificationAlert[] {
    const alerts: NotificationAlert[] = [];
    printerProofUserList = _.sortBy(printerProofUserList, "updatedOn");
    for (const alert of printerProofUserList) {
      if (alert.actionTaken && alert.actionTaken.toLowerCase().indexOf('rejected') > -1) {
        alerts.push({ type: NOTIFICATION_ERROR, message: `${alert.actionTaken} by ${alert.firstName} ${alert.lastName} ${convertUTCDateToLocalDateMMDDYYYYHHMMSS(alert.updatedOn)}` });
      } else {
        alerts.push({ type: NOTIFICATION_SUCCESS, message: `${alert.actionTaken} by ${alert.firstName} ${alert.lastName} ${convertUTCDateToLocalDateMMDDYYYYHHMMSS(alert.updatedOn)}` });
      }
    }
    return alerts;
  }

  private getPrinterProofData(workflowID: string, yearCode: string): void {
    this.showLoader = true;
    this.manageWorkflow
      .getPrinterProofFilesData(workflowID, yearCode)
      .subscribe(
        (response) => {
          const data = response.value;
          this.header = data.headerDetails && data.headerDetails.length && data.headerDetails[0];
          this.printerProofForm = null;
          setTimeout(() => {
            this.printerProofForm = this.getPrinterProofFormControls();
          }, 0);
          this.alerts = this.getAllAlerts(data.printerProofUserList);
          this.comments = this.getAllComments(data.printerProofCommentsList);
          if (data && data.printerProofList.length) {
            this.printerProofData = data.printerProofList;
            this.PrinterProofHeaders = this.getPrinterProofHeaders();
            this.isNonConsentedCP = this.getLoggedUserConsentStatus(this.printerProofData[0]);
          } else {
            this.printerProofData = [];
            this.isNonConsentedCP = false;
          }
          this.showLoader = false;
        },
        (error) => {
          this.alert = {
            type: NOTIFICATION_ERROR,
            message: SOMETHING_WENT_WRONG,
          };
          this.showLoader = false;
        }
      );
  }

  public onExit(): void {
    this.showUnsavedPopup = false;
    // this.resetForm();
  }

  public submitPrinterProof(): void {
    this.showLoader = true;
    const data = {
      yearCode: this.yearCode,
      workflowID: this.workflowID,
      loginID: this.coreService.getLoggedInID().toString(),
      rejectReason: null
    };
    this.manageWorkflow.approveByORCWorkflow(data).subscribe((resolve) => {
      this.showSubmittedPrinterProofPopUp = true;
      this.getPrinterProofData(this.workflowID, this.yearCode);
    }, (error) => {
      this.showLoader = false;
      this.toasterNotificationService.showErrorNotification('Your data entry has not been submitted for review.');
    });
  }

  public submitPrinterProofForm(): void {
    this.submittedPrinterProofForm = true;
    this.alert = null;
    const printerProofFormData = this.printerProofForm.getRawValue();
    printerProofFormData.isActive = '1';
    printerProofFormData.IsPrinterProof = '1';
    printerProofFormData.fileTypeCode = '-1';
    printerProofFormData.documentComment = '-1';
    if (this.printerProofForm.valid) {
      this.showLoader = true;
      if (checkForSameFile(this.printerProofData, this.formFileValue)) {
        this.submittedPrinterProofForm = false;
        const fileVal = new FormData();
        fileVal.append('wfID', this.workflowID);
        fileVal.append('fileTypeCode', printerProofFormData.fileTypeCode);
        fileVal.append('fileName', this.formFileValue.name);
        fileVal.append('filePath', this.formFileValue);
        fileVal.append('description', printerProofFormData.description);
        fileVal.append('fileUploadStatusCode', '-1');
        fileVal.append('documentComment', printerProofFormData.documentComment);
        fileVal.append('IsPrinterProof', printerProofFormData.IsPrinterProof);
        fileVal.append('IsActive', printerProofFormData.isActive);
        fileVal.append('yearCode', this.yearCode);
        fileVal.append('loginID', this.coreService.getLoggedInID().toString());
        this.manageWorkflow
          .postPrinterProofFilesData(fileVal)
          .subscribe((resolve) => {
            this.printerProofForm = this.getPrinterProofFormControls();
            this.getPrinterProofData(this.workflowID, this.yearCode);
            this.toasterNotificationService.showSuccessNotification('Document has been successfully uploaded');
            this.showLoader = false;
          });
      } else {
        this.showLoader = false;
        this.alert = {
          type: NOTIFICATION_ERROR,
          message: `${DUPLICATE_FILE_ERROR}`,
        };
      }
    } else {
      this.alert = {
        type: NOTIFICATION_ERROR,
        message: `${FILL_ALL_MANDATORY_FIELDS}`,
      };
    }
  }
  public selectFile(event): void {
    this.formFileValue = event;
    this.alert = null;
    const fileExt = this.formFileValue.name.split('.');
    if (
      !(fileExt[fileExt.length - 1] === 'jpeg' || fileExt[fileExt.length - 1] === 'jpg' || fileExt[fileExt.length - 1] === 'pdf')
    ) {
      this.alert = {
        type: NOTIFICATION_ERROR,
        message: `${ALLOWED_FORMAT}`,
      };
      this.printerProofForm.controls.file.setValue(null);
    }
    if (fileExt[0] && fileExt[0].length > 100) {
      this.alert = {
        type: NOTIFICATION_ERROR,
        message: `${DOCUMENT_FILE_SIZE}`,
      };
      this.printerProofForm.controls.file.setValue(null);
    }
  }

  public closeDeletePopup(): void {
    this.showDeletePopup = false;
  }

  public onDeleteUploadedDocument(): void {
    this.showLoader = true;
    this.showDeletePopup = false;
    this.selectedDelDocument.isActive = '0';
    const fileVal = new FormData();
    fileVal.append('isActive', this.selectedDelDocument.isActive);
    this.manageWorkflow
      .updatePrinterProofData(fileVal, this.selectedDelDocument.id)
      .subscribe(
        (response) => {
          if (response) {
            this.alert = {
              type: NOTIFICATION_SUCCESS,
              message: `${PRINTER_PROOF_DELETED}`,
            };
          }
          this.submittedPrinterProofForm = false;
          this.getPrinterProofData(this.workflowID, this.yearCode);
          // if (this.printerProofData.length === 1) {
          //   this.restartWorkflowIfNoPrinterProof(this.selectedDelDocument);
          // } else {
          //   this.getPrinterProofData(this.workflowID, this.yearCode);
          // }
        },
        (error) => {
          this.showLoader = false;
          this.alert = {
            type: NOTIFICATION_ERROR,
            message: `${ERROR_OCCURED_TRY_AGAIN_LATER}`,
          };
        }
      );
  }

  public restartWorkflowIfNoPrinterProof(dataSelectedForRestart): void {
    this.showLoader = true;
    const loggedUser = this.coreService.getLoggedInUserDetails();
    const workflowData = {
      actionID: 0,
      yearCode: this.yearCode,
      workflowID: this.workflowID,
      loginID: loggedUser.loginID,
      comments: null,
    };
    this.manageWorkflow.resetWorkflow(workflowData).subscribe(
      (response) => {
        setTimeout(() => {
          this.getPrinterProofData(this.workflowID, this.yearCode);
        }, 3000);
      },
      (error) => {
        this.showLoader = false;
      }
    );
  }

  public downloadFile(userFile: PrinterProofFileUploadDetails): void {
    this.manageWorkflow.getPrinterProofDownload(userFile.id).subscribe(
      (response: UserFileDownload) => {
        const sampleBytes = base64ToArrayBuffer(response.fileContents);
        saveByteArray([sampleBytes], response.fileDownloadName);
      },
      (error) => {
        this.alert = {
          type: NOTIFICATION_ERROR,
          message: `${ERROR_OCCURED_TRY_AGAIN_LATER}`,
        };
      }
    );
  }



  public onFileUploadDataDelete(
    printerProofData: PrinterProofFileUploadDetails
  ): void {
    const documentName = printerProofData.fileName;
    this.selectedDelDocument = printerProofData;
    this.showDeletePopup = true;
    this.popupMessage = `Once you delete the ${documentName} document it cannot be recovered. Would you like to continue?`;
  }

  // get user file form
  public getPrinterProofFormControls(user?: UserDetail): FormGroup {
    const disableStatus = !(this.header.workflowStatus === '8');
    return new FormGroup({
      file: new FormControl({ value: null, disabled: disableStatus }, [Validators.required]),
      isPrimary: new FormControl(null),
      isActive: new FormControl('1'),
      description: new FormControl({ value: null, disabled: disableStatus }, [Validators.required]),
    });
  }
  public openLink(event): void { }
  public getPrinterProofHeaders(): WorkflowTableGridHeader[] {
    const headers = [
      {
        name: 'Document Name',
        key: 'fileName',
        sortType: 'string',
        type: 'link-searchName',
      },
      {
        name: 'Uploaded by',
        key: 'uploadedBy',
        sortType: 'string',
        type: 'string',
      },
      {
        name: 'Description',
        key: 'description',
        sortType: 'string',
        type: 'string',
      },
      { name: 'Date', key: 'uploadDate', type: 'date' }
    ];
    if (this.isAdmin) {
      const deleteIconHeader: any = { name: '', key: '', type: 'delete-download-button' };
      if (this.printerProofData && this.printerProofData.length) {
        if (this.printerProofData[0].isConsentPublished) {
          deleteIconHeader.type = 'download-button';
        }
      }
      if (this.header.workflowStatus !== '8') {
        deleteIconHeader.type = 'download-button';
        headers.push(deleteIconHeader);
      } else {
        headers.push(deleteIconHeader);
      }
    } else if (this.isEndorser || this.isCPQP || this.isConsumer || this.isORC) {
      headers.push({ name: '', key: '', type: 'download-button' });
    }
    return headers;
  }

  /**
   * BacktoManageWorkflow
   */
  public BacktoManageWorkflow(): void {
    this.showSubmittedPrinterProofPopUp = false;
    this.router.navigateByUrl(this.DASHBOARD_URL);
  }

  /**
   * submitAcknowledgement
   */
  public submitAcknowledgement(): void {
    this.showLoader = true;
    const data: ApproveWorkflowModel = {
      actionID: 1,
      loginID: this.coreService.getLoggedInID().toString(),
      workflowID: this.workflowID,
      yearCode: this.yearCode,
      rejectReason: null
    };
    this.manageWorkflow.verifyWorkflowApprovedRejectedByEndorser(data)
      .subscribe((resolve) => {
        this.showApprovedPopup = true;
        this.getPrinterProofData(this.workflowID, this.yearCode);
      }, (error) => {
        this.showLoader = false;
        this.alert = { type: NOTIFICATION_ERROR, message: SOMETHING_WENT_WRONG };
      });
  }

  /**
   * rejectedByEndorser
   */
  public rejectedByEndorser() {
    this.commentControl = new FormControl(null, [Validators.required, TextValidator(300)]);
    this.showRejectedPopup = true;
    this.submitCommentForm = false;
  }

  public rejectedByCPQP(): void {
    this.commentControl = new FormControl(null, [Validators.required, TextValidator(300)]);
    this.showCpQpRejectedPopup = true;
    this.submitCommentForm = false;
  }

  /**
   * ConsentToPublish
   */
  public ConsentToPublish(): void {
    this.router.navigateByUrl(`${this.DASHBOARD_URL}/${CONSENT_TO_PUBLISH}/${this.coreService.getLoggedInID()}/${this.workflowID}/${this.yearCode}`);
  }

  /**
   * closeRejectionPopup
   */
  public closeRejectionPopup(): void {
    this.showRejectedPopup = false;
    this.submitCommentForm = false;
  }

  public closeCpQpRejectionPopup(): void {
    this.showCpQpRejectedPopup = false;
    this.submitCommentForm = false;
  }

  /**
   * confirmRejection
   */
  public confirmCpQpRejection(): void {
    this.showCpQpRejectedPopup = false;
    this.showLoader = true;
    this.submitCommentForm = true;
    if (this.commentControl.valid) {
      const commentObj = {
        userName: this.coreService.getLoggedInUserDetails().displayName,
        updatedDate: new Date(),
        comment: this.commentControl.value
      };
      const data: ApproveWorkflowModel = {
        actionID: 0,
        loginID: this.coreService.getLoggedInID().toString(),
        workflowID: this.workflowID,
        yearCode: this.yearCode,
        rejectReason: JSON.stringify(commentObj)
      };
      this.manageWorkflow.verifyWorkflowApprovedRejectedByCPQP(data)
        .subscribe((resolve) => {
          this.showCpQpRejectedPopup = false;
          this.showLoader = false;
          this.toasterNotificationService.showSuccessNotification('Reason for rejection has been saved.');
          this.getPrinterProofData(this.workflowID, this.yearCode);
        }, (error) => {
          this.showLoader = false;
          this.alert = { type: NOTIFICATION_ERROR, message: SOMETHING_WENT_WRONG };
        });
    }
  }

  /**
   * confirmRejection
   */
  public confirmRejection(): void {
    this.showRejectedPopup = false;
    this.showLoader = true;
    this.submitCommentForm = true;
    if (this.commentControl.valid) {
      const commentObj = {
        userName: this.coreService.getLoggedInUserDetails().displayName,
        updatedDate: new Date(),
        comment: this.commentControl.value
      };
      const data: ApproveWorkflowModel = {
        actionID: 0,
        loginID: this.coreService.getLoggedInID().toString(),
        workflowID: this.workflowID,
        yearCode: this.yearCode,
        rejectReason: JSON.stringify(commentObj)
      };
      this.manageWorkflow.verifyWorkflowApprovedRejectedByEndorser(data)
        .subscribe((resolve) => {
          this.showRejectedPopup = false;
          this.showLoader = false;
          this.toasterNotificationService.showSuccessNotification('Reason for rejection has been saved.');
          this.getPrinterProofData(this.workflowID, this.yearCode);
        }, (error) => {
          this.showLoader = false;
          this.alert = { type: NOTIFICATION_ERROR, message: SOMETHING_WENT_WRONG };
        });
    }
  }

  viewComments(): void {
    this.showComments = true;
  }

  getLoggedUserConsentStatus(item): boolean {
    const users = item.wfUser && item.wfUser.split(',');
    if (this.isCPQP && users && users.indexOf(this.coreService.getLoggedInID().toString()) === -1) {
      return true;
    } else if (this.isCPQP && !item.wfUser) {
      return true;
    }
    return false;
  }

  viewConsents(): void {
    this.alert = null;
    this.showLoader = true;
    this.manageWorkflow.getConsentedUserList(this.workflowID, this.yearCode).subscribe((response) => {
      this.consentedFormsData = response;
      this.showConsentedForms = true;
      this.showLoader = false;
    }, (error) => {
      this.showLoader = false;
      this.alert = { type: NOTIFICATION_ERROR, message: SOMETHING_WENT_WRONG };
    });
  }

  onDownload(event): void {
    this.alert = null;
    this.consentAlert = null;
    this.showLoader = true;
    this.manageWorkflow.getWorkflowUserOnBehalfFilesDownload(event.wfid, '1', event.loginID, event.consentFileName).subscribe(
      (response: UserFileDownload) => {
        this.showLoader = false;
        const sampleBytes = base64ToArrayBuffer(response.fileContents);
        saveByteArray([sampleBytes], response.fileDownloadName);
      },
      (error) => {
        this.showLoader = false;
        this.consentAlert = {
          type: NOTIFICATION_ERROR,
          message: `${ERROR_OCCURED_TRY_AGAIN_LATER}`,
        };
      }
    );
  }

  onRowSelect(consentData): void {
    this.viewConsentForm = true;
    this.selectedConsent = consentData;
  }
}
